module.exports = __webpack_public_path__ + "img/tuna.91894386.png";